import React from 'react';
import PropTypes from 'prop-types';
import { DetailsRow, DetailsRowCheck } from '@fluentui/react';
import { RowFieldsWithFreeze } from './row-field-with-freeze';

export const CampaignDetailsRow = (props) => {
  const {
    freezingColumnCount, freezingColumnRTLCount, selectionMode, item,
  } = props;
  const renderCheckbox = (_props) => {
    if (item.disableCheckbox) {
      return <DetailsRowCheck {..._props} onRenderDetailsCheckbox={() => null} />;
    }
    return <DetailsRowCheck {..._props} />;
  };

  if (freezingColumnCount > 0 || freezingColumnRTLCount > 0) {
    const rowField = _props => <RowFieldsWithFreeze freezingCount={freezingColumnCount} freezingRTLCount={freezingColumnRTLCount} selectionMode={selectionMode} {..._props} />;
    return <DetailsRow {...props} rowFieldsAs={rowField} onRenderCheck={renderCheckbox} />;
  }
  return <DetailsRow {...props} onRenderCheck={renderCheckbox} />;
};

CampaignDetailsRow.propTypes = {
  freezingColumnCount: PropTypes.number,
  freezingColumnRTLCount: PropTypes.number,
  selectionMode: PropTypes.number,
  item: PropTypes.shape({}),
};

CampaignDetailsRow.defaultProps = {
  freezingColumnCount: 0,
  freezingColumnRTLCount: 0,
  selectionMode: 0,
  item: {},
};
